"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserService = void 0;
var _user = require("../controllers/user.controller");
var UserService = {
  root: {
    getUser: _user.config.root + "/getUserDetail",
    userLatestDetail: _user.config.root + "/getUserDetail/latest"
  },
  crm: {
    detail: _user.config.crm + "/detail",
    redirect: _user.config.crm + "/authorize"
  },
  user: {
    mail: _user.config.user + "/mail",
    user: _user.config.user,
    organization: _user.config.user + "/organization",
    list: _user.config.user + "/list",
    adminList: _user.config.user + "/admin/list",
    softDelete: _user.config.user + "/delete/soft",
    hardDelete: _user.config.user + "/delete/hard",
    restore: _user.config.user + "/delete/soft/restore",
    softDeletedList: _user.config.user + "/list/soft/deleted",
    uniqueEmail: _user.config.user + "/unique/email",
    bulkHardDelete: _user.config.user + "/bulk/delete/hard",
    bulkActivate: _user.config.user + "/bulk/activate",
    bulkDeactivate: _user.config.user + "/bulk/deactivate",
    activities: _user.config.user + "/activities",
    authorizeDevice: _user.config.root + "/authorize-device",
    userActivateUser: _user.config.user + "/status/activate",
    userDeactivateUser: _user.config.user + "/status/deactivate",
    resetPasswordCommon: _user.config.user + "/reset-password/delegate",
    tenantPermission: _user.config.user + "/permission",
    userAdmin: _user.config.user + "/admin",
    bulkSoftDelete: _user.config.user + "/bulk/delete/soft",
    bulkSoftDeleteRestore: _user.config.user + "/bulk/delete/soft/restore",
    deletedByList: _user.config.user + "/deleted-by-user/list"
  },
  general: {
    resetPassword: _user.config.general + "/reset-password",
    changeStatus: _user.config.general + "/change-status",
    forgotPassword: _user.config.general + "/forgot-password/mail",
    savePassword: _user.config.general + "/save-password",
    uniqueAccess: _user.config.general + "/unique/access",
    validatePassword: _user.config.general + "/validate/password",
    validateToken: _user.config.general + "/validate/token"
  },
  group: {
    group: _user.config.group,
    list: _user.config.group + "/list",
    count: _user.config.group + "/count",
    delete: _user.config.group + "/delete/hard"
  },
  authenticate: {
    delegateAccess: _user.config.authenticate + "/delegate-access",
    logout: _user.config.authenticate + "/logout"
  },
  userAdminPlatform: {
    validatePassword: _user.config.userAdminPlatform + "/validate/password",
    userAdminPlatform: _user.config.userAdminPlatform,
    hardDelete: _user.config.userAdminPlatform + "/delete/hard",
    list: _user.config.userAdminPlatform + "/list",
    resetPassword: _user.config.userAdminPlatform + "/reset-password",
    activate: _user.config.userAdminPlatform + "/status/activate",
    deactivate: _user.config.userAdminPlatform + "/status/deactivate",
    softDelete: _user.config.userAdminPlatform + "/delete/soft",
    softDeleteRestore: _user.config.userAdminPlatform + "/delete/soft/restore",
    softDeletedList: _user.config.userAdminPlatform + "/list/soft/deleted",
    deletedByList: _user.config.userAdminPlatform + "/deleted-by-user/list",
    deletedByListTenant: _user.config.userAdminPlatform + "/deleted-by-user/tenant/list"
  },
  userAdminPlatformBulk: {
    hardDelete: _user.config.userAdminPlatformBulk + "/delete/hard",
    activate: _user.config.userAdminPlatformBulk + "/activate",
    deactivate: _user.config.userAdminPlatformBulk + "/deactivate",
    softDelete: _user.config.userAdminPlatformBulk + "/delete/soft",
    restore: _user.config.userAdminPlatformBulk + "/delete/soft/restore"
  },
  userAdminBrand: {
    search: _user.config.userAdminBrand + "/list",
    assign: _user.config.userAdminBrand + "/assign",
    find: _user.config.userAdminBrand + "/linked/list"
  },
  userAdminReport: {
    assign: _user.config.userAdminReport + "/assign"
  },
  userAdminContent: {
    assign: _user.config.userAdminContent + "/assign"
  },
  userAdminApplication: {
    assign: _user.config.userAdminApplication + "/assign"
  },
  userAdminData: {
    assign: _user.config.userAdminData + "/assign"
  },
  apiKey: {
    search: _user.config.apiKey + "/master",
    list: _user.config.apiKey + "/list",
    create: _user.config.apiKey,
    delete: _user.config.apiKey,
    master: _user.config.apiKey + "/master",
    update: _user.config.apiKey + "/master"
  },
  role: {
    add: _user.config.role,
    update: _user.config.role,
    delete: _user.config.role,
    fetch: _user.config.role,
    list: _user.config.role + "/list"
  },
  totp: {
    fetch: _user.config.totp + "/qr",
    public: _user.config.totp + "/public/qr",
    validate: _user.config.totp + "/public/validate-setup",
    validateProfile: _user.config.totp + "/validate-setup",
    verify: _user.config.totp + "/public/verify",
    delete: _user.config.totp + "/remove"
  },
  info: {
    fetch: _user.config.info,
    add: _user.config.info,
    update: _user.config.info,
    namingList: _user.config.info + "/naming-convention/list",
    timezone: _user.config.info + "/default-timezone/list"
  },
  deviceInfo: {
    fetch: _user.config.deviceInfo,
    add: _user.config.deviceInfo,
    update: _user.config.deviceInfo,
    delete: _user.config.deviceInfo + "/delete/hard",
    list: _user.config.deviceInfo + "/list"
  },
  masterPassCode: {
    update: _user.config.masterPassCode
  },
  userProfileInfo: {
    fetch: _user.config.userProfileInfo,
    update: _user.config.userProfileInfo
  },
  siteSetting: {
    update: _user.config.siteSetting,
    siteInfo: _user.config.siteSetting
  },
  reportSetting: {
    update: _user.config.reportSetting,
    reportInfo: _user.config.reportSetting
  },
  updateEmail: {
    update: _user.config.systemAdminUser + "/system/email"
  },
  userLog: {
    listSession: _user.config.userLog + "/list",
    listSessionActivity: _user.config.userLog + "/activity/list"
  }
};
exports.UserService = UserService;